export enum StaffingUnitType {
  Unassigned = 0,
  Project,
  Standalone,
  Vacation,
  SickLeave,
  ServiceProject,
  Administration,
}
